
import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const NotFound = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-lawyer-light">
      <div className="text-center px-4">

        <div className="mb-8">
          <img 
            src="/404.png" 
            alt="Página não encontrada" 
            className="h-44 mx-auto"
          />
        </div>
        <h1 className="text-2xl font-semibold mb-4 text-lawyer-dark">Página não encontrada</h1>
        <p className="text-gray-600 max-w-md mx-auto mb-8">
          Parece que esta página não existe ou foi movida para outro endereço. Verifique o URL ou retorne à página inicial.
        </p>
        <Link 
          to="/" 
          className="inline-flex items-center bg-lawyer-primary hover:bg-lawyer-accent text-white font-medium py-3 px-6 rounded-md transition-colors"
        >
          <ArrowLeft className="h-5 w-5 mr-2" />
          Voltar ao Início
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
